import { Position } from 'reactflow';

import styles from './NodeTypes.module.scss';
import { HiddenHandle } from './common';
import { EdgePlusButton } from '../EdgeTypes';
import { NodeProps } from '../types';

type PlaceholderPlusButtonNodeProps = Omit<NodeProps, 'data'> & {
	data: Omit<NodeProps['data'], 'edge' | 'onClick' | 'isMoveNodeActive' | 'isNewNodeFloatingMenuEnabled'> & {
		edge: NonNullable<NodeProps['data']['edge']>;
		onClick: NonNullable<NodeProps['data']['onClick']>;
		isMoveNodeActive: NonNullable<NodeProps['data']['isMoveNodeActive']>;
		isNewNodeFloatingMenuEnabled: NonNullable<NodeProps['data']['isNewNodeFloatingMenuEnabled']>;
	};
};
export default function PlaceholderPlusButtonNode({
	data,
	sourcePosition = Position.Top,
	targetPosition = Position.Bottom,
}: PlaceholderPlusButtonNodeProps) {
	return (
		<div className={styles.centerizeSmallNode}>
			<HiddenHandle type="source" position={sourcePosition} />
			<EdgePlusButton
				onPlusClick={data.onClick}
				isMoveNodeActive={data.isMoveNodeActive}
				floatingMenuEnabled={data.isNewNodeFloatingMenuEnabled}
			/>
			<HiddenHandle type="target" position={targetPosition} />
		</div>
	);
}
